import Collection from '@/components/Collection'
import CreateTransfer from '@/pages/transfer/CreateForm'
import UpdateTransfer from '@/pages/transfer/UpdateForm'
import access from "../access";

const domainNs = "urn:ietf:params:xml:ns:domain-1.0";

export default {

  'transfer.collection': {
    path: '/admin/transfers',
    name: 'transfer.collection',
    component:  Object.assign({}, Collection), // https://stackoverflow.com/a/41425312
    props: {
      handler: "listTransfers",
      entity: "transfer",
      cols: [
        { label: "Domain", field: "name" },
        { label: "Author", field: "requested_by", sort: "requested_by" },
        { label: "Owner", field: "domain_registrar", sort: "domain_registrar" },
        { label: "Date", field: "requested_at", sort: "requested_at", date: "date" },
        { label: "Valid until", field: "valid_until", sort: "valid_until", date: "date" },
        { label: "New domain expiration date", field: "expire_at", sort: "expire_at", date: "date" },
        { label: "Period", field: "period", sort: "period" }
      ],
      actions: (row) => {
        return [
          { name: "transfer.update", label: "take action", icon: "hammer2", params: {id: row.id} }
        ];
      }
    },
    meta: {
      access: access.chain(access.authenticated, access.service(domainNs)),
      title: "Domain transfer list",
      side_menu: { label: "Transfers",  icon: "tab" },
      local_actions: [
        { name: "transfer.create", label: "Create transfer", color: "success", icon: "plus" }
      ]
    },
  },

  'transfer.create': {
    path: '/admin/transfers/create',
    name: 'transfer.create',
    component: CreateTransfer,
    meta: {
      access: access.chain(access.authenticated, access.service(domainNs)),
      title: "Request domain transfer"
    },
  },

  'transfer.update': {
    path: '/admin/transfers/update/:id',
    name: 'transfer.update',
    component: UpdateTransfer,
    props: (route) => {
      return {
        id: Number(route.params.id),
      }
    },
    meta: {
      access: access.chain(access.authenticated, access.service(domainNs)),
      title: "Update domain transfer"
    },
  },

}



// WEBPACK FOOTER //
// ./src/routes/modules/transfer.js